import React, { useEffect, useState } from "react";
import moment from "moment";
import "./SalesWizardPage.scss";
import SalesForm1 from "../../forms/SalesForm1";
import SalesForm2 from "../../forms/SalesForm2";
import SalesForm3 from "../../forms/SalesForm3";
import { Box } from "@mui/material";
import DefaultButton from "../../components/DefaultButton";
import { connect, useSelector } from "react-redux";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import { SalesCombinedEncRow } from "../../constants/Sales";
import { getSpeciesName } from "../../constants/Catch";
import { getCurrentOpenTrip } from "../../constants/vtrTrip";
import { useNavigate, useLocation } from "react-router-dom";
import {
  validateMultiSales,
  validateSalesExtra,
} from "../../constants/salesValidations";
import Spinner from "../../components/common/Spinner";
import TitleBar from "../../components/TitleBar";
import Grid from "@mui/material/Grid";
import { success } from "../../constants/colors";

function SalesWizardPage(props) {
  const { actions } = props;
  const { auth, vtrTrip, helpText, validation } = useSelector((state) => state);
  const location = useLocation();
  const navigate = useNavigate();
  const [values, setValues] = useState({
    isLoaded: false,
    isExisting: false,
    report_type: null,
    trip_type: null,
    sold: null,
    display_date_sold: "",
    date_sold: "",
    species: "",
    dealer_permit_number: "",
    dealer_name: "",
    offloading_port: "",
    currentStep: 1,
    sales: [],
    selectedSales: [],
    maximumStep: 2,
    price_per_bushel: "",
    allocation_numbers: [],
    tag_numbers: [],
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    console.group("SalesPageMount");
    let currentTrip = getCurrentOpenTrip(
      vtrTrip.allOpenTrips,
      location.state.trip_id
    );
    let speciesList = validation.validations.species;
    let newState = {};
    let tripType = currentTrip.trip_type;
    newState.report_type = currentTrip.report_type;
    newState.trip_type = tripType;
    newState.trip_id = location.state.trip_id;

    let sumCatch = [];
    let allCatch = [];
    let speciesDone = [];
    let catchSpecies = [];
    let salesSpecies = [];
    let allEfforts = currentTrip.images;
    let allSales = currentTrip.sales;
    let sumSales = [];

    allEfforts.forEach((effort) => {
      if (effort.hasOwnProperty("catch")) {
        allCatch = allCatch.concat(effort.catch);
      }
    });

    allCatch.forEach((item) => {
      if (item.species && Number(item.kept) > 0) {
        if (!catchSpecies.includes(item.species)) {
          sumCatch.push({
            species: item.species,
            kept: Number(item.kept),
            uom: item.uom,
          });
          catchSpecies.push(item.species);
        } else {
          sumCatch.forEach((sum) => {
            if (sum.species === item.species) {
              sum.kept = Number(item.kept) + Number(sum.kept);
              return;
            }
          });
        }
      }
    });

    allSales.forEach((sales) => {
      if (sales.species && Number(sales.sold) > 0) {
        if (!salesSpecies.includes(sales.species)) {
          sumSales.push({
            species: sales.species,
            sold: Number(sales.sold),
            uom: sales.uom,
          });
          salesSpecies.push(sales.species);
        } else {
          sumSales.forEach((item) => {
            if (item.species === sales.species) {
              item.sold = Number(sales.sold) + Number(item.sold);
              return;
            }
          });
        }
      }
    });

    speciesDone = salesSpecies.concat(
      catchSpecies.filter((item) => salesSpecies.indexOf(item) < 0)
    );
    let combinedSum = [];
    speciesDone.forEach((item) => {
      let enc = new SalesCombinedEncRow();
      let currentCatch;
      let currentSale;
      sumCatch.forEach((sum) => {
        if (sum.species === item) {
          currentCatch = sum;
          return;
        }
      });
      sumSales.forEach((sale) => {
        if (sale && sale.hasOwnProperty("species") && sale.species === item) {
          currentSale = sale;
          return;
        }
      });
      enc.setSold(0);
      if (currentCatch && currentSale) {
        enc.setSpecies(currentCatch.species);
        enc.setCatchUom(currentCatch.uom);
        enc.setOriginalAvailable(currentCatch.kept - currentSale.sold);
        enc.setAvailable(currentCatch.kept - currentSale.sold);
        enc.setOriginalSold(0);
        enc.setTotalSold(currentSale.sold);
        enc.setTotalAvailable(currentCatch.kept);
        enc.setSalesUom(currentSale.uom);
      } else if (currentCatch && !currentSale) {
        enc.setSpecies(currentCatch.species);
        enc.setCatchUom(currentCatch.uom);
        enc.setOriginalAvailable(currentCatch.kept);
        enc.setAvailable(currentCatch.kept);
        enc.setOriginalSold(0);
        enc.setTotalSold(0);
        enc.setTotalAvailable(currentCatch.kept);
        enc.setSalesUom(currentCatch.uom);
      } else {
        enc.setSpecies(currentSale.species);
        enc.setCatchUom(currentSale.uom);
        enc.setOriginalAvailable(0);
        enc.setAvailable(0);
        enc.setTotalAvailable(0);
        enc.setTotalSold(currentSale.sold);
        enc.setOriginalSold(currentSale.sold);
        enc.setSalesUom(currentSale.uom);
      }
      enc.setSpeciesLabel(getSpeciesName(enc.species, speciesList));
      combinedSum.push(enc);
    });
    const catchAvailable = combinedSum.some(
      (obj) => obj.total_sold < obj.total_available
    );
    console.info(combinedSum);
    newState.combinedSales = combinedSum;
    newState.isLoaded = true;
    newState.isCatchAvailable = catchAvailable;
    console.log(newState);
    console.groupEnd();

    setValues({ ...values, ...newState });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _next = (event) => {
    event.preventDefault();
    window.scrollTo(0, 0);
    let errors1 = [];
    let errors2 = [];
    let errors3 = [];
    if (values.currentStep === 1) {
      console.group("sales_next");
      console.log(values.sales);
      console.log(values.sales.length);
      console.log(Array.isArray(values.sales));
      console.groupEnd();

      if (!Array.isArray(values.sales) || values.sales.length === 0) {
        errors1 = "No Species selected";
      }
    }
    if (values.currentStep === 2) {
      errors2 = validateMultiSales(values);
    }
    if (values.currentStep === 3) {
      errors3 = validateSalesExtra(values);
    }
    let allErrors = errors1.concat(errors2, errors3);
    actions.setError(allErrors);
    if (allErrors.length > 0) {
      return;
    }
    setValues({ ...values, currentStep: values.currentStep + 1 });
    if (values.currentStep === values.maximumStep) {
      actions.newSales(values, auth.client_id, values.trip_id);
    }
  };

  const _back = (event) => {
    event.preventDefault();
    setValues({ ...values, currentStep: values.currentStep - 1 });
  };

  const _cancel = (event, value) => {
    event.preventDefault();
    let errors = [];
    actions.setError(errors);
    if (value === "Cancel") {
      actions.setTripRedirect();
    }
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleMultiSoldChange = (event, salesNr) => {
    event.preventDefault();
    console.group("handleMultiSoldChange");

    const newSold = event.target.value;
    let currentSales = values.selectedSales;
    const originalSold = currentSales[salesNr].original_sold;
    const totalKept = currentSales[salesNr].original_available;
    const originalAvailable = Number(totalKept) - Number(originalSold);
    const diffSold = Number(originalSold) - Number(newSold);
    let totalSold = 0;
    let salesAvailable = 0;
    if (Number(originalSold) > Number(newSold)) {
      totalSold = Number(originalSold) - diffSold;
      salesAvailable = Number(totalKept) - totalSold;
    }
    if (Number(originalSold) < Number(newSold)) {
      totalSold = Number(originalSold) - diffSold;
      salesAvailable = Number(totalKept) - totalSold;
    }
    if (Number(originalSold) === Number(newSold)) {
      salesAvailable = originalAvailable;
    }
    console.log(totalSold);
    console.log(salesAvailable);

    currentSales[salesNr].sold = Number(newSold);
    currentSales[salesNr].available = salesAvailable;
    console.table(currentSales);
    console.groupEnd();
    if (newSold < 0) {
      console.error("newSold " + newSold + " smaller than zero");
      return;
    }
    if (newSold > originalAvailable) {
      console.error(
        "New sold " +
          newSold +
          " larger than amount available " +
          originalAvailable
      );
      return;
    }
    setValues({
      ...values,
      selectedSales: currentSales,
    });
  };

  const handleMultiCatchDispositionChange = (event, newValues) => {
    event.preventDefault();
    console.group("handleMultiCatchDispositionChange");
    console.info(event);
    console.log(newValues);
    let newSales = {};
    let selectedSales = [];

    newValues.forEach((value) => {
      let comboSales = values.combinedSales;
      comboSales.forEach((sales) => {
        if (sales.species === value) {
          selectedSales.push(sales);
        }
      });
    });
    newSales.sales = newValues;
    newSales.selectedSales = selectedSales;

    if (selectedSales.length > 0) {
      //Default amount of steps.
      let maximumSteps = 2;
      //Sales selected check if we have selected one of the following species,
      // in that case we need to ask the SFCLAM specific question on the next page
      const incrementedWizard = selectedSales.some((obj) =>
          ["CLHB", "CLQUB", "CLSOB", "CLSUB"].includes(obj.species)
      );
      if (values.report_type === "3" && incrementedWizard) {
        maximumSteps = 3;
      }
      newSales.maximumStep = maximumSteps;
    }
    console.log(newSales);
    console.groupEnd();
    setValues({ ...values, ...newSales });
  };

  const _showConfirm = (event) => {
    event.preventDefault();
    setValues({ ...values, showModal: true });
  };

  const handlePricePerBushel = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setValues({ ...values, [name]: parseFloat(value).toFixed(2) });
  };

  const handleAllocationChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    const newAllocationNumber = [...values.allocation_numbers];
    newAllocationNumber[0] = value;
    setValues({ ...values, [name]: [...newAllocationNumber] });
  };

  const handleDeleteTagRange = (idx) => {
    const reduceArr = [...values.tag_numbers];
    reduceArr.splice(idx, 1);
    values({ ...values, tag_numbers: reduceArr });
  };

  const handleTagNumberRangeChange = (value) => {
    let newTagNumbers = [...values.tag_numbers];
    newTagNumbers.push(value);
    setValues({ ...values, tag_numbers: [...newTagNumbers] });
  };

  const dealerChangeHandler = function (event, reason) {
    event.preventDefault();
    if (reason) {
      //Save the new values when selected
      if (
        reason.hasOwnProperty("DEALER_PERMIT_NUMBER") &&
        reason.hasOwnProperty("DEALER_NAME")
      ) {
        setValues({
          ...values,
          dealer_permit_number: reason.DEALER_PERMIT_NUMBER,
          dealer_name: reason.DEALER_NAME,
        });
      }
    } else {
      //If emptied then empty the state
      setValues({ ...values, dealer_permit_number: "", dealer_name: "" });
    }
  };

  const handleDealerPreferenceChange = function (event) {
    event.preventDefault();
    let dealerName = event.currentTarget.dataset.dealer_name;
    let dealerPermitNumber = event.currentTarget.dataset.dealer_permit_number;
    if (!dealerPermitNumber) {
      console.log("No new dealer permit number provided");
      return;
    }
    if (!dealerName) {
      console.log("No new dealer name provided");
      return;
    }

    setValues({
      ...values,
      dealer_name: dealerName,
      dealer_permit_number: dealerPermitNumber,
    });
  };

  const portChangeHandler = function (event, reason) {
    event.preventDefault();
    if (reason) {
      setValues({
        ...values,
        offloading_port: reason.ID,
        port_name: reason.NAME,
        port_state: reason.STATE,
        port_city: reason.CITY,
        my_name: reason.my_name,
      });
    } else {
      //If emptied then empty the state
      setValues({
        ...values,
        offloading_port: "",
        port_name: "",
        port_state: "",
        port_city: "",
      });
    }
  };

  const handlePortPreferenceChange = function (event) {
    event.preventDefault();
    let portId = event.currentTarget.dataset.port_id;
    let portName = event.currentTarget.dataset.port_name;
    let portState = event.currentTarget.dataset.port_state;
    let portCity = event.currentTarget.dataset.port_city;

    let newState = {};
    newState.port_name = portName;
    newState.offloading_port = portId;
    newState.port_city = portCity;
    newState.port_state = portState;
    console.info("prefchange", newState);
    setValues({ ...values, ...newState });
  };

  const DateSoldNowHandler = function (event) {
    event.preventDefault();
    let d = moment();
    const format = "DD-MMM-YY";
    let newState = {};
    newState.date_sold = d.format("YYMMDD");
    newState.display_date_sold = d.format(format);
    setValues({ ...values, ...newState });
  };

  const dateSoldHandler = function (date) {
    if (date && date.hasOwnProperty("_d")) {
      let newDateTime = date._d;
      if (newDateTime !== "") {
        const dt = moment(newDateTime, "DD-MM-YYYY");
        let bDateTime = dt.format("YYMMDD");
        setValues({
          ...values,
          display_date_sold: newDateTime,
          date_sold: bDateTime,
        });
      } else {
        setValues({ ...values, display_date_sold: newDateTime, date_sold: "" });
      }
    } else {
      setValues({ ...values, display_date_sold: "", date_sold: "" });
    }
  };

  useEffect(() => {
    if (vtrTrip.redirect && values.isLoaded) {
      return navigate(`${process.env.PUBLIC_URL}/vtr-trip-review`, {
        state: {
          trip_id: values.trip_id,
          client_id: auth.client_id,
        },
      });
    }
  }, [
    navigate,
    auth.client_id,
    values.isLoaded,
    values.trip_id,
    vtrTrip.redirect,
  ]);

  if (values.isLoaded === false) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }

  return (
    <div className="SalesWizardPage margAll10" data-testid="SalesWizardPage">
      <TitleBar
        title="Catch Disposition"
        delete_button={values.isExisting === true ? _showConfirm : false}
        client_id={auth.client_id}
        trip_id={values.trip_id}
        sales_id={values.sales_id}
      />

      <SalesForm1
        trip_id={values.trip_id}
        species={values.species}
        handleCatchDispositionChange={handleMultiCatchDispositionChange}
        currentStep={values.currentStep}
        sales={values.sales}
        combinedSales={values.combinedSales}
      />
      <SalesForm2
        currentStep={values.currentStep}
        handleMultiSoldChange={handleMultiSoldChange}
        sales={values.selectedSales}
        trip_type={values.trip_type}
        handleInputChange={handleInputChange}
        helpText={helpText.helpText}
        dealer_permit_number={values.dealer_permit_number}
        dealer_name={values.dealer_name}
        dealerChangeHandler={dealerChangeHandler}
        handleDealerPreferenceChange={handleDealerPreferenceChange}
        portChangeHandler={portChangeHandler}
        handlePortPreferenceChange={handlePortPreferenceChange}
        port_id={values.offloading_port}
        port_state={values.port_state}
        port_name={values.port_name}
        port_city={values.port_city}
        DateSoldNowHandler={DateSoldNowHandler}
        display_date_sold={values.display_date_sold}
        dateSoldHandler={dateSoldHandler}
      />
      {values.report_type === "3" && values.maximumStep === 3 && (
        <SalesForm3
          currentStep={values.currentStep}
          trip_type={values.trip_type}
          species={values.species}
          pricePerBushel={values.price_per_bushel}
          allocationNumbers={values.allocation_numbers}
          tagNumbers={values.tag_numbers}
          handleInputChange={handleInputChange}
          handlePricePerBushel={handlePricePerBushel}
          handleDeleteTag={handleDeleteTagRange}
          handleTagChange={handleTagNumberRangeChange}
          handleAllocationChange={handleAllocationChange}
        />
      )}

      <Box
        mt={5}
        width="100%"
        align="center"
        className="bottom-nav-container margBot20"
      >
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs="auto" className="margRight20">
            <DefaultButton
              changeHandler={values.currentStep === 1 ? _cancel : _back}
              buttonText={values.currentStep === 1 ? "Cancel" : "Back"}
            />
          </Grid>
          {values.isCatchAvailable && (
            <Grid item xs="auto" className="margRight20">
              <DefaultButton
                changeHandler={_next}
                buttonText={
                  values.currentStep !== values.maximumStep ? "Next" : "Save"
                }
                bgColor={success}
              />
            </Grid>
          )}
        </Grid>
      </Box>
    </div>
  );
}

export default connect(mapVtrStateToProps, mapDispatchToProps)(SalesWizardPage);
